import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49cedd6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-9" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "welcome-title" }, " Seja bem-vindo(a) ao Portal de Comissão para Revendas ")
], -1))
const _hoisted_3 = { class: "w-[20rem] h-[4rem] flex flex-col space-y-1 mt-8 items-center" }
const _hoisted_4 = { class: "profile-container" }
const _hoisted_5 = { class: "profile-name text-right text-v_dark_gray" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { className: " border-[1px] mb-5" }, null, -1))
const _hoisted_7 = { class: "flex justify-evenly w-48 font-[800]" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { className: "mt-5 border-[1px] " }, null, -1))

import { removeItems } from "@/utils/permissions"
import { useRouter } from "vue-router"
import { hasPermission } from "@/utils/permissions"
import { Permission, TypeOfUser, Profile, Notification } from "@/utils/enum"
import { useStore } from "@/store"
import { watchEffect, ref } from "vue"
import { RESET_STATES } from "@/store/mutationsTypes"
import { updateUsers } from "@/repositories/users"
import { IUpdateUser } from "@/utils/interfaces"


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  emits: [
	"changeProfile",
	"enableLoading",
	"emitError",
	"successfullyUpdated",
	"showModalChangePassword"
],
  setup(__props, { emit }) {

/* eslint-disable*/
const store = useStore()

const items = [
	{ title: 'Alterar a senha' },
	{ title: 'Sair' },
]

const router = useRouter()

const name = ref("")

let showInput = ref(false)
let welcomeMessage = ref("Bem vindo ao Portal Comissão")
let profile = ref(Profile.COMMISSION)

const logout = () => {
	router.push({ path: "/" })
	removeItems()
	store.commit(RESET_STATES)
}

const changeProfile = (value: Profile) => {
	if (profile.value != value) {
		profile.value = value
		emit("changeProfile", value)
	}

	if (value == Profile.COMMISSION) {
		welcomeMessage.value = "Bem vindo ao Portal Comissão"
	} else if (value == Profile.FAQ) {
		welcomeMessage.value = "FAQ Portal Comissão"
	}
}

const editResaleName = async () => {
	emit("enableLoading", true)

	const user = store.getters.getUserRev

	const data: IUpdateUser = {
		name: name.value,
	}

	const res = await updateUsers(user.id, data)

	if (res.status == 204) {
		emit(
			"successfullyUpdated",
			true,
			Notification.TITLE_USER_EDIT,
			Notification.SUBTITLE_USER_EDIT
		)
	} else if (res == 400) {
		emit(
			"emitError",
			true,
			Notification.TITLE_UPDATE_ERROR,
			Notification.SUBTITLE_UPDATE_ERROR
		)
	} else {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	emit("enableLoading", false)

	showInput.value = false
}

watchEffect(() => {
	name.value = store.getters.getResaleName
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_menu, {
          location: "bottom start",
          origin: "auto"
        }, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, " Olá, " + _toDisplayString(name.value), 1),
              _createVNode(_component_v_btn, _mergeProps({
                icon: "mdi-account",
                variant: "tonal"
              }, props, { class: "profile-button" }), null, 16)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, i) => {
                  return _createVNode(_component_v_list_item, {
                    key: i,
                    value: i
                  }, {
                    default: _withCtx(() => [
                      (i == 0)
                        ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showModalChangePassword', true)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (i == 1)
                          ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                              key: 1,
                              onClick: logout
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.title), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeProfile(_unref(Profile).COMMISSION))),
          class: "active:scale-90"
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_unref(profile) == _unref(Profile).COMMISSION &&
					'text-v_green underline decoration-v_green underline-offset-[1.7rem] decoration-2'
					)
          }, _toDisplayString(_unref(TypeOfUser).COMMISSION), 3)
        ]),
        (_unref(hasPermission)([_unref(Permission).ADMIN]))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "text-v_dark_gray2 active:scale-90",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeProfile(_unref(Profile).USER)))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_unref(profile) == _unref(Profile).USER &&
					'text-v_green underline decoration-v_green underline-offset-[1.7rem] decoration-2'
					)
              }, _toDisplayString(_unref(TypeOfUser).USER), 3)
            ]))
          : _createCommentVNode("", true),
        (_unref(hasPermission)([_unref(Permission).RESALE]))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "text-v_dark_gray2 active:scale-90",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (changeProfile(_unref(Profile).FAQ)))
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(_unref(profile) == _unref(Profile).FAQ &&
					'text-v_green underline decoration-v_green underline-offset-[1.7rem] decoration-2'
					)
              }, " Dúvidas ", 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_8
    ])
  ], 64))
}
}

})